module.exports = "../dist/img/payanyway.00b9.png";